<template>
  <a
    :key="link + index"
    :href="link.url"
    class="avatar-dropdown-placeholder__link-icons col-4"
    @click="avatarMenuClick(link.text)"
  >
    <div class="avatar-dropdown-placeholder__icon-wrapper">
      <svgicon
        v-if="link.iconUrl"
        :name="link.iconUrl"
      />
      <div
        v-else
        class="svg-icon"
      />
      <span
        v-if="link.notification"
        class="badge badge--icon-position-up-right"
        v-text="link.notification"
      />
    </div>
    <span
      class="avatar-dropdown-placeholder__text"
      v-text="link.text"
    />
  </a>
</template>

<script>
import ga from "@/analytics/dataLayerTopNav"
import "#/Shop/ShoppingCart"
import "#/Shop/ShoppingList"
import "#/Climate/ClimateGoals"
import "#/Shop/Bonus"
import "#/Shop/AccountBalance"
import "#/Shop/ShoppingList"
import "#/Users/User"
import "#/Controls/Rate"
import "#/Delivery/HomeDelivery"

export default {
  name: "AvatarLink",
  props: {
    link: {
      type: Object,
      default () {
        return {}
      }
    },
    index: {
      type: Number,
      default: 0
    }

  },
  data () {
    return {
      track: ga
    }
  },
  methods: {
    toggleAvatar () {
      this.active = !this.active
    },
    avatarMenuClick (text) {
      this.track.avatarMenuClick(text)
      this.toggleAvatar()
    }
  }
}
</script>
